import { CREATE_STORE_CATEGORY_URL, DELETE_STORE_CATEGORY_URL, DELETE_STORE_URL, GET_STORE_ADDON_CATEGORIES_URL, GET_ALL_STORE_CATEGORIES_URL, GET_STORE_ITEMS_URL, GET_STORE_ITEM_CATEGORIES_URL, GET_SINGLE_STORE_URL, GET_STORE_ITEM_URL, TOGGLE_STORE_CATEGORY_URL, TOGGLE_STORE_URL,DEACTIVATE_STORE_URL, UPDATE_STORE_CATEGORY_URL, UPDATE_STORE_URL, UPDATE_STORE_ITEM_URL, BULK_UPLOAD_STORE_URL, ACCEPT_STORE_URL, GET_ALL_PENDING_STORES_URL, GET_ITEM_ADDON_CATEGORY_URL, UPDATE_ITEM_ADDON_CATEGORY_URL } from "../../../config";
import axiosClient from "../../../helpers/axios-client";
import { CLOSE_FORM_LOADING, FORM_SUBMISSION_STATUS } from "../../common/actionTypes";
import { GET_ALL_STORE_CATEGORIES, GET_STORE_ITEMS, GET_STORE_ITEM_CATEGORIES, GET_SINGLE_STORE, GET_STORE_ADDON_CATEGORIES, STORE_BULK_UPLOAD, ACCEPT_STORE, GET_ALL_PENDING_STORES, GET_ITEM_ADDON_CATEGORY, UPDATE_ITEM_ADDON_CATEGORY, GET_STORE_ITEM } from "./actionType";
import { CREATE_STORE_URL, GET_ALL_STORES_URL, GET_STORE_SORT_ITEM_CATEGORIES_URL, GET_STORE_SORT_ITEMS_URL, UPDATE_ITEM_POSITION_FOR_STORE_URL, UPDATE_ITEM_CATEGORY_POSITION_FOR_STORE_URL, UPDATE_STORE_POSITION_URL } from "../../../config";
import { GET_ALL_STORES, GET_STORE_SORT_ITEMS, GET_STORE_SORT_ITEM_CATEGORIES } from "./actionType";


//store category

export const getAllStoreCategories = () => (dispatch) => {
    return axiosClient.post(GET_ALL_STORE_CATEGORIES_URL).then((response) => {
        if (response && response.data.success) {
            const categories = response.data.data;
            return dispatch({ type: GET_ALL_STORE_CATEGORIES, payload: categories });
        }
    }).catch(function (error) {
        console.log(error);
    });
};

export const toggleCategory = (id) => (dispatch) => {
    return axiosClient.post(TOGGLE_STORE_CATEGORY_URL, { id, });
};

export const deleteCategory = (id) => (dispatch) => {
    return axiosClient.post(DELETE_STORE_CATEGORY_URL, { id, }).then((response) => {
        dispatch({ type: CLOSE_FORM_LOADING, });
        dispatch({ type: FORM_SUBMISSION_STATUS, payload: true, });
    });
};

export const createStoreCategory = (data) => (dispatch) => {
    const config = {
        headers: { Accept: 'application/json', 'Content-Type': 'multipart/form-data', }
    }
    return axiosClient.post(CREATE_STORE_CATEGORY_URL, data, config).then((response) => {
        dispatch({ type: CLOSE_FORM_LOADING, });
        dispatch({ type: FORM_SUBMISSION_STATUS, payload: true, });
    });
};


export const updateStoreCategory = (data, id) => (dispatch) => {
    console.log(data, 'actionnnn')
    const config = {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'multipart/form-data',
        }
    }
    return axiosClient.post(UPDATE_STORE_CATEGORY_URL, data, config).then((response) => {
        dispatch({ type: CLOSE_FORM_LOADING, });
        dispatch({
            type: FORM_SUBMISSION_STATUS,
            payload: true,
        });
    });
};

//stores
export const getAllStores = () => (dispatch) => {
    return axiosClient.post(GET_ALL_STORES_URL).then((response) => {
        if (response && response.data.success) {
            const stores = response.data.data;
            return dispatch({ type: GET_ALL_STORES, payload: stores });
        }
    }).catch(function (error) {
        console.log(error);
    });
};

export const getSingleStore = (id) => (dispatch) => {
    return axiosClient.post(GET_SINGLE_STORE_URL, { id }).then((response) => {
        if (response && response.data.success) {
            const store = response.data.store;
            return dispatch({ type: GET_SINGLE_STORE, payload: store });
        }
    }).catch(function (error) {
        console.log(error);
    });
};

export const getStoreSortItemCategories = (id) => (dispatch) => {
    return axiosClient.post(GET_STORE_SORT_ITEM_CATEGORIES_URL, { id }).then((response) => {
        if (response && response.data.success) {
            const categories = response.data;
            return dispatch({ type: GET_STORE_SORT_ITEM_CATEGORIES, payload: categories });
        }
    }).catch(function (error) {
        console.log(error);
    });
};


export const getStoreSortItems = (id) => (dispatch) => {
    return axiosClient.post(GET_STORE_SORT_ITEMS_URL, { id }).then((response) => {
        if (response && response.data.success) {
            const categories = response.data;
            return dispatch({ type: GET_STORE_SORT_ITEMS, payload: categories });
        }
    }).catch(function (error) {
        console.log(error);
    });
};


export const updateStorePosition = (newOrder) => (dispatch) => {
    return axiosClient.post(UPDATE_STORE_POSITION_URL, { newOrder });
};

export const updateItemCategoryPositionForStore = (newOrder) => (dispatch) => {
    return axiosClient.post(UPDATE_ITEM_CATEGORY_POSITION_FOR_STORE_URL, { newOrder });
};

export const updateItemPositionForStore = (newOrder) => (dispatch) => {
    return axiosClient.post(UPDATE_ITEM_POSITION_FOR_STORE_URL, { newOrder });
};

export const getStoreItem = (formData) => (dispatch) => {
    return axiosClient.post(GET_STORE_ITEM_URL, formData).then((response) => {
        if (response && response.data.success) {
            const item = response.data;
            return dispatch({ type: GET_STORE_ITEM, payload: item });
        }
    }).catch(function (error) {
        console.log(error);
    });
};


export const updateStoreItem = (data) => (dispatch) => {
    const config = {
        headers: { Accept: 'application/json', 'Content-Type': 'multipart/form-data', }
    }
    return axiosClient.post(UPDATE_STORE_ITEM_URL, data, config).then((response) => {
        dispatch({ type: CLOSE_FORM_LOADING });
        dispatch({ type: FORM_SUBMISSION_STATUS, payload: true });
    });
};


export const getItemAddonCategory = (formData) => (dispatch) => {
    return axiosClient
        .post(GET_ITEM_ADDON_CATEGORY_URL, formData)
        .then((response) => {
            if (response && response.data.success) {
                const item = response.data;
                return dispatch({ type: GET_ITEM_ADDON_CATEGORY, payload: item });
            }
        })
        .catch(function (error) {
            console.log(error);
        });
};

export const updateItemAddonCategory = (formData) => (dispatch) => {
    return axiosClient
        .post(UPDATE_ITEM_ADDON_CATEGORY_URL, formData)
        .then((response) => {
            if (response && response.data.success) {
                const item = response.data;
                return dispatch({ type: UPDATE_ITEM_ADDON_CATEGORY, payload: item });
            }
        })
        .catch(function (error) {
            console.log(error);
        });
};



export const createStore = (data) => (dispatch) => {
    const config = {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'multipart/form-data',
        }
    }
    return axiosClient.post(CREATE_STORE_URL, data, config)
        .then((response) => {
            dispatch({
                type: CLOSE_FORM_LOADING,
            });

            dispatch({
                type: FORM_SUBMISSION_STATUS,
                payload: true,
            });
        }).catch(error => {
            console.log(error);
        });

};

export const toggleStore = (id) => (dispatch) => {
    return axiosClient.post(TOGGLE_STORE_URL, {
        id,
    });
};

export const deactivateStore = (id) => (dispatch) => {
    return axiosClient.post(DEACTIVATE_STORE_URL, {
        id,
    });
};

export const updateStore = (data) => (dispatch) => {
    const config = {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'multipart/form-data',
        }
    }
    return axiosClient
        .post(UPDATE_STORE_URL,
            data, config
        )
        .then((response) => {
            dispatch({
                type: CLOSE_FORM_LOADING,
            });

            dispatch({
                type: FORM_SUBMISSION_STATUS,
                payload: true,
            });
        });
};


export const deleteStore = (id) => (dispatch) => {
    return axiosClient.post(DELETE_STORE_URL, {
        id,
    }).then((response) => {
        dispatch({
            type: CLOSE_FORM_LOADING,
        });
        dispatch({
            type: FORM_SUBMISSION_STATUS,
            payload: true,
        });
    });
};
export const getStoreItemCategories = (id) => (dispatch) => {
    return axiosClient
        .post(GET_STORE_ITEM_CATEGORIES_URL, { id })
        .then((response) => {
            if (response && response.data.success) {
                const categories = response.data.data;
                return dispatch({ type: GET_STORE_ITEM_CATEGORIES, payload: categories });
            }
        })
        .catch(function (error) {
            console.log(error);
        });
};
export const getStoreItems = (id) => (dispatch) => {
    return axiosClient
        .post(GET_STORE_ITEMS_URL, { id })
        .then((response) => {
            if (response && response.data.success) {
                const items = response.data.data;
                return dispatch({ type: GET_STORE_ITEMS, payload: items });
            }
        })
        .catch(function (error) {
            console.log(error);
        });
};
export const getStoreAddonCategories = (id) => (dispatch) => {
    return axiosClient
        .post(GET_STORE_ADDON_CATEGORIES_URL, { id })
        .then((response) => {
            if (response && response.data.success) {
                const categories = response.data.data;
                return dispatch({ type: GET_STORE_ADDON_CATEGORIES, payload: categories });
            }
        })
        .catch(function (error) {
            console.log(error);
        });
};

export const bulkUpload = (file, token) => (dispatch) => {
    const config = {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'multipart/form-data',
        }
    }
    return axiosClient
        .post(BULK_UPLOAD_STORE_URL, { file }, config
        )
        .then((response) => {
            if (response && response.data.success) {
                const data = response.data;
                return dispatch({
                    type: STORE_BULK_UPLOAD,
                    payload: data
                })
            }

        });
};

export const getAllPendingStores = () => (dispatch) => {
    return axiosClient
        .post(GET_ALL_PENDING_STORES_URL)
        .then((response) => {
            if (response && response.data.success) {
                const stores = response.data.data;
                return dispatch({ type: GET_ALL_PENDING_STORES, payload: stores });
            }
        })
        .catch(function (error) {
            console.log(error);
        });
};

export const acceptStore = (id) => (dispatch) => {
    return axiosClient.post(ACCEPT_STORE_URL, {
        id,
    }).then((response) => {
        if (response && response.data.success) {
            const data = response.data;
            return dispatch({
                type: ACCEPT_STORE,
                payload: data
            })
        }

    });
};
